import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

const xTick = { fontSize: 11, fill: '#999' };
const yTick = { fontSize: 11, fill: '#999' };

export function GSCDailyChart({ daily, clientName, formatDate }) {
  if (!daily || daily.length === 0) return null;

  return (
    <div className="bg-white border border-neutral-200 p-5">
      <h2 className="font-heading font-semibold text-lg text-neutral-900 mb-4">
        Performance quotidienne — {clientName}
      </h2>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={daily}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="date" tickFormatter={formatDate} tick={xTick} />
          <YAxis yAxisId="left" tick={yTick} />
          <YAxis yAxisId="right" orientation="right" tick={yTick} />
          <Tooltip labelFormatter={(d) => new Date(d).toLocaleDateString('fr-FR')} />
          <Line yAxisId="left" type="monotone" dataKey="clicks" stroke="#002FA7" strokeWidth={2} dot={false} name="Clics" />
          <Line yAxisId="left" type="monotone" dataKey="impressions" stroke="#2A9D8F" strokeWidth={2} dot={false} name="Impressions" />
          <Line yAxisId="right" type="monotone" dataKey="position" stroke="#E76F51" strokeWidth={2} dot={false} name="Position" />
        </LineChart>
      </ResponsiveContainer>
      <div className="flex gap-6 justify-center mt-3">
        <div className="flex items-center gap-2 text-sm"><div className="w-3 h-3 rounded-full bg-[#002FA7]" />Clics</div>
        <div className="flex items-center gap-2 text-sm"><div className="w-3 h-3 rounded-full bg-[#2A9D8F]" />Impressions</div>
        <div className="flex items-center gap-2 text-sm"><div className="w-3 h-3 rounded-full bg-[#E76F51]" />Position</div>
      </div>
    </div>
  );
}
